export default "__VITE_ASSET__BzRBXE9K__"